export default __webpack_public_path__ + "static/PurePlank-f28be39c5ef0ed699f47a633faa3574b.webp";